import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const statusBadgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
  {
    variants: {
      variant: {
        success: "bg-[hsl(var(--status-success-bg))] text-[hsl(var(--status-success-fg))]",
        warning: "bg-[hsl(var(--status-warning-bg))] text-[hsl(var(--status-warning-fg))]",
        error: "bg-[hsl(var(--status-error-bg))] text-[hsl(var(--status-error-fg))]",
        info: "bg-[hsl(var(--status-info-bg))] text-[hsl(var(--status-info-fg))]",
        neutral: "bg-[hsl(var(--status-neutral-bg))] text-[hsl(var(--status-neutral-fg))]",
      },
    },
    defaultVariants: {
      variant: "neutral",
    },
  },
);

export type StatusBadgeVariant = VariantProps<typeof statusBadgeVariants>["variant"];

export interface StatusBadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof statusBadgeVariants> {
  label: string;
  icon?: React.ElementType;
}

export function StatusBadge({ label, icon: Icon, variant, className, ...props }: StatusBadgeProps) {
  return (
    <span className={cn(statusBadgeVariants({ variant }), Icon && "gap-1.5", className)} {...props}>
      {Icon && <Icon className="h-3 w-3" />}
      {label}
    </span>
  );
}
